import { Outlet } from 'react-router-dom';
import NotFoundPage from '../Pages/404Page';
import BenefitLayout from '../layout/layouts/BenefitLayout';

interface PrivateRouteProps {
  isPowerUser: boolean;
}

const PrivateRoute = (props: PrivateRouteProps) => {
  return props.isPowerUser ? (
    <Outlet />
  ) : (
    <BenefitLayout>
      <NotFoundPage />
    </BenefitLayout>
  );
};

export default PrivateRoute;
